import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {createPopper} from '@popperjs/core/lib/popper-lite.js';
import type {Instance} from '@popperjs/core';

@customElement('element-dropdown')
export class ElementDropdown extends LitElement {
  containerElement: HTMLElement;
  toggleElement: HTMLElement;
  popper: Instance = null;

  static override get styles() {
    return css`
      :host {
        display: contents;
      }
    `;
  }

  override connectedCallback() {
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target as Node)) {
        this.hide();
      }
    });
    super.connectedCallback();
  }

  containerSlotReady(event: Event) {
    const containers = (event.target as HTMLSlotElement).assignedElements();
    console.assert(
      containers.length === 1,
      'Only one container element is allowed',
    );
    this.containerElement = containers.at(0) as HTMLElement;

    this.hide();
  }

  toggleSlotReady(event: Event) {
    const toggles = (event.target as HTMLSlotElement).assignedElements();
    console.assert(toggles.length === 1, 'Only one toggle element is allowed');
    this.toggleElement = toggles.at(0) as HTMLElement;
  }

  show() {
    this.containerElement.classList.remove('hidden');
    console.assert(this.popper === null, 'Popper already initialized');
    // FIXME: make placement configurable
    this.popper = createPopper(this.toggleElement, this.containerElement, {
      placement: 'bottom-end',
    });
  }

  hide() {
    this.containerElement.classList.add('hidden');
    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
    }
  }

  toggle() {
    if (this.containerElement.classList.contains('hidden')) {
      this.show();
    } else {
      this.hide();
    }
  }

  override render() {
    return html`
      <slot
        @slotchange="${this.toggleSlotReady}"
        @click="${this.toggle}"
        name="toggle"
      ></slot>
      <slot @slotchange="${this.containerSlotReady}"></slot>
    `;
  }
}
